import { render, staticRenderFns } from "./CourseStatus.vue?vue&type=template&id=70ee20be"
import script from "./CourseStatus.vue?vue&type=script&lang=js"
export * from "./CourseStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports